// removed by extract-text-webpack-plugin
module.exports = {"container-fluid":"JJxScTZiWCGt68Rd3U8qh","Card":"_2e9LeZc28TGZaio1gNmnh5","PaginationWrap":"_3pyxpA0V_yqLaZY64jplri","ActiveLink":"xIAhvM7oyu0IRDCXxQsn5","ExportBar":"_30hhxWXSZVp8VhLcaXHL4m","ExportBtn":"_1IRRYbUJqBV42ao6oQnFn8"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/AntiFraudLog/antifraudLog.module.css
// module id = 626
// module chunks = 0